import { VideoTutorial } from "@/common/api.service"
import { FETCH_VIDEO_DATA } from "./actions.type"
import { SET_VIDEO_DATA } from "./mutations.type"

const initialState = () => {
    return {
        videotutorialdata: [],
    }
}

let state = initialState()

const getters = {
    videotutorialdata(state) {
        return state.videotutorialdata
    }
}

const actions = {
    async [FETCH_VIDEO_DATA](context, slug) {
        const { data } = await VideoTutorial.get(slug)
        context.commit(SET_VIDEO_DATA, data.data)
        return data;
    },    
 }

const mutations = {
    [SET_VIDEO_DATA](state, videodata) {
        state.videotutorialdata = videodata
    },
}

export default {
    state,
    getters,
    actions,
    mutations
};